import { studentRequests } from "api/studentApi";
import { useEffect } from "react";
import { ReferenceInput } from "react-admin";
import { useFormContext, useWatch } from "react-hook-form";
import AutoPickSelectInput from "server/components/Fields/AutoPickSelectInput";

const LanguageSelectInput = ({ defVal, readOnly }) => {
  const curriculumId = useWatch({ name: "curriculumId" });
  const { setValue } = useFormContext();

  useEffect(() => {
    if (defVal) {
      setValue("instructionLanguageId", defVal, { shouldDirty: false });
    }
  }, [defVal, setValue]);

  if (!curriculumId) return null;

  return (
    <ReferenceInput
      key={curriculumId}
      source="instructionLanguageId"
      reference={studentRequests.getCurriculumLanguagesSelect(curriculumId)}
    >
      <AutoPickSelectInput
        source="instructionLanguageId"
        label="Език на преподаване"
        optionText="name"
        fullWidth
        isRequired
        emptyText={false}
        readOnly={readOnly}
        onChange={() => {
          setValue("academicYearId", null);
          setValue("studyTypeId", null);
          setValue("academicYearSessionId", null);
          setValue("disciplineId", null);
        }}
      />
    </ReferenceInput>
  );
};

export default LanguageSelectInput;
